import {ActionTypes} from '../ActionTypes';
import {endpoints, http} from '../../configs/http';


const getTemplateRequest = () => {
  return {
    type: ActionTypes.GET_TEMPLATE_REQUEST,
    isLoading: true,
    failed: false,
    message: null,
  };
};

const getTemplateSuccess = (data) => {
  return {
    type: ActionTypes.GET_TEMPLATE_SUCCESS,
    data: data,
    failed: false,
    isLoading: false,
  };
};

const getTemplateFailure = (message) => {
  return {
    type: ActionTypes.GET_TEMPLATE_FAILURE,
    isLoading: false,
    failed: true,
    message: message,
  };
};

export const getPaymentTemplate = () => {
  return (dispatch) => {
    // dispatch pending
    dispatch(getTemplateRequest());
    http
      .get(endpoints.GET_PAYMENT_TEMPLATE)
      .then(async (resp) => {
        dispatch(getTemplateSuccess(resp));
        // await asyncStore(STORE_KEYS.TEMPLATE_DATA, resp);
      })
      .catch(async (err) => {
        console.log(err);

        // let template = await asyncGet(STORE_KEYS.TEMPLATE_DATA);
        // if (template) {
        //   dispatch(getTemplateSuccess(template));
        // }
        dispatch(getTemplateFailure(err));
      });
  };
};
